import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-page',
  imports: [ CommonModule ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  providers: [],
})
export class PageComponent {
  /** Determines whether the sidebar remains fixed while scrolling the content area. */
  fixed = input<boolean>(false);
  /** Sets the background color of the sidebar. Options include gray, white or custom. */
  sidebarBackground = input<'white' | 'gray' | `#${string}`>();

  /** Returns a style object for setting the background color of the sidebar. */
  getSidebarStyle(): { [key: string]: string } {
    const bg = this.sidebarBackground();

    if (bg) {
      if (bg === 'white') {
        return { '--background-color': 'var(--background-color-white)' };
      }

      if (/^#([0-9A-F]{3}){1,2}$/i.test(bg)) {
        return { '--background-color': bg };
      }
    }

    return {};
  }
}
